import React from "react";

import styled, { keyframes } from "styled-components";

import theme from "../../../theme";
import loaderLogoUrl from "./loaderLogoUrl";

const logoPulse = keyframes`
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.92; transform: scale(1.02); }
`;

const barSlide = keyframes`
    0% { transform: translateX(-100%); }
    100% { transform: translateX(350%); }
`;

const textFade = keyframes`
    0%, 100% { opacity: 0.7; }
    50% { opacity: 1; }
`;

const Wrapper = styled.div`
    display: flex;
    position: fixed;
    inset: 0;
    z-index: 99999999;
    align-items: center;
    justify-content: center;
    background: #fff;
`;

const Inner = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
`;

const LogoWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Logo = styled.img`
    width: 180px;
    max-width: 180px;
    height: 62px;
    object-fit: contain;
    animation: ${logoPulse} 2s ease-in-out infinite;
`;

const Bar = styled.div`
    width: 200px;
    height: 4px;
    border-radius: 2px;
    background: #e2e8f0;
    overflow: hidden;
`;

const BarFill = styled.div`
    height: 100%;
    width: 40%;
    border-radius: 2px;
    background: ${() => theme.palette.primary.main};
    animation: ${barSlide} 1.4s ease-in-out infinite;
`;

const Text = styled.p`
    margin: 0;
    font-size: 0.875rem;
    font-weight: 500;
    color: #64748b;
    letter-spacing: 0.02em;
    animation: ${textFade} 1.5s ease-in-out infinite;
`;

const AppLoader = () => (
    <Wrapper role="status" aria-label="Loading">
        <Inner>
            <LogoWrap>
                <Logo
                    src={loaderLogoUrl}
                    alt="Signal Sight"
                    width="180"
                    height="62"
                    decoding="sync"
                    loading="eager"
                />
            </LogoWrap>
            <Bar>
                <BarFill />
            </Bar>
            <Text>Loading your workspace...</Text>
        </Inner>
    </Wrapper>
);

export default AppLoader;
